module.exports = __webpack_public_path__ + "img/Hayat.4fbb117a.png";